import { useNavigate } from "react-router-dom";
import "../../../../../Booking/DateSelector/DateSelector.scss";
import '../Variations/variations.scss'
const Variations = ({ variations, onSelect, formData, setFormData, setUser }) => {
    const variationsList = JSON.parse(variations);
    const navigate = useNavigate()

    return (
        <div className="variations-container">
            <div className="title">
             <strong>Prices & Dates</strong>   
            </div>
            <div className="date-table">
                <div className="date-header">
                    <span>Date</span>
                    <span>Seats Left</span>
                    <span>Price</span>
                    <span>Action</span>
                </div>

                {variationsList.map((item, index) => (
                    <div
                        key={index}
                        className="date-row"
                        onClick={() => {
                            onSelect(item);
                            setFormData({
                                ...formData,
                                date: item.dateRange,
                                amount: item.price
                            })
                            setUser()
                        }}
                    >
                        <span>{item.dateRange}</span>
                        <span>{item.seatsAvailable} Seats</span>
                        <span>${item.price}</span>
                        <span className="select-btn">Select</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Variations;
